import { PointGroup } from 'signature_pad';
import Decimal from 'decimal.js';

/* eslint-disable no-restricted-syntax */
type Dimensions = {
  width: number;
  height: number;
};

export function scalePadData(data: PointGroup[], oldDimensions: Dimensions, newDimensions: Dimensions) {
  const { width: oldWidth, height: oldHeight } = oldDimensions;
  const { width: newWidth, height: newHeight } = newDimensions;

  const wRatio = new Decimal(newWidth).div(oldWidth);
  const hRatio = new Decimal(newHeight).div(oldHeight);

  if (wRatio.eq(1) && hRatio.eq(1)) return data;

  const newData = [];

  for (const stroke of data) {
    const newStroke: PointGroup = {
      ...stroke,
      points: [],
    };

    for (const point of stroke.points) {
      const newX = wRatio.mul(point.x);
      const newY = hRatio.mul(point.y);

      newStroke.points.push({
        x: newX.toNumber(),
        y: newY.toNumber(),
        pressure: point.pressure,
        time: point.time,
      });
    }

    newData.push(newStroke);
  }

  return newData;
}
